export default "__VITE_ASSET__AU9fDWNt__"